import { TELEGRAM_URL } from '../config/media';

function TelegramIcon() {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d="M22 2 11 13M22 2l-7 20-4-9-9-4 20-7z" />
    </svg>
  );
}

function BookButton({ href = TELEGRAM_URL }) {
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className="inline-flex items-center gap-2 rounded-full border border-black bg-white px-5 py-2 font-sans text-[0.6875rem] uppercase tracking-[0.14em] text-black no-underline transition-opacity hover:opacity-60 md:px-6 md:py-2.5"
    >
      <TelegramIcon />
      Записаться
    </a>
  );
}

function PriceFeatures({ features }) {
  return (
    <ul className="m-0 list-disc space-y-1.5 pl-5 text-sm leading-relaxed text-black">
      {features.map((feature) => (
        <li key={feature.text} className={feature.bold ? 'font-semibold' : 'font-normal'}>
          {feature.text}
        </li>
      ))}
    </ul>
  );
}

function PriceContent({ category, title, features, price, extraNote, disclaimer }) {
  return (
    <div className="text-left">
      {category && (
        <p className="mb-1 text-sm font-light text-neutral-500 md:text-base">{category}</p>
      )}
      <h2 className="mb-5 text-xl font-normal uppercase leading-snug text-black md:mb-6 md:text-2xl">
        {title}
      </h2>
      <PriceFeatures features={features} />
      <p className="mb-1 mt-6 text-2xl font-normal text-black md:mt-8 md:text-[1.75rem]">{price}</p>
      {extraNote && (
        <p className="m-0 mt-1 text-sm font-normal text-black">({extraNote})</p>
      )}
      {disclaimer && <p className="mt-2 text-xs text-neutral-500">{disclaimer}</p>}
    </div>
  );
}

function PriceUnit({
  variant = 'card',
  image,
  category,
  title,
  features,
  price,
  extraNote,
  disclaimer,
  telegramUrl,
}) {
  if (variant === 'main') {
    return (
      <article className="w-full">
        <div className="flex flex-col gap-8 md:flex-row md:items-start md:gap-12">
          <div className="w-full shrink-0 md:w-1/2">
            <img
              src={image}
              alt={title}
              className="block aspect-[3/4] w-full object-cover bg-neutral-100"
            />
          </div>
          <div className="w-full md:w-1/2">
            <PriceContent
              category={category}
              title={title}
              features={features}
              price={price}
              extraNote={extraNote}
              disclaimer={disclaimer}
            />
          </div>
        </div>
        <div className="mt-10 flex justify-center md:mt-12">
          <BookButton href={telegramUrl} />
        </div>
      </article>
    );
  }

  return (
    <article className="flex h-full w-full flex-col">
      <img
        src={image}
        alt={title}
        className="block aspect-[3/4] w-full object-cover bg-neutral-100"
      />
      <div className="flex flex-1 flex-col pt-5">
        <PriceContent
          category={category}
          title={title}
          features={features}
          price={price}
          extraNote={extraNote}
          disclaimer={disclaimer}
        />
        <div className="mt-8 flex justify-center">
          <BookButton href={telegramUrl} />
        </div>
      </div>
    </article>
  );
}

export default PriceUnit;
